/*
 * @Author: Dadamuga Mazino 
 * @Date: 2018-01-11 14:59:17 
 * @Last Modified by: Dadamuga Mazino
 * @Last Modified time: 2018-03-07 11:04:14
 */
import "babel-polyfill";
import dotenv from 'dotenv';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

import "./assets/vendor/bootstrap/dist/css/bootstrap.min.css"
import "./assets/vendor/font-awesome/css/font-awesome.min.css"
import "./assets/vendor/owl.carousel/dist/assets/owl.carousel.min.css"
import "./assets/vendor/magnific-popup/dist/magnific-popup.css"
import "./assets/vendor/icomoon/style.css"
import "./assets/css/animate.min.css"
import "./assets/css/style.css"
import "./assets/css/color/default.css"

dotenv.config();

ReactDOM.render(<App />, document.getElementById('root'));

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js